import ChatImageGallery from "./ChatImageGallery";
export default ChatImageGallery;
